import { IS_BILLING, IS_DEV } from "@/constants";
import PublicLayout from "@/layouts/PublicLayout";
import CompleteProfile from "@/modules/CompleteProfile";
import ForgetPassword from "@/modules/ForgetPassword";
import Login from "@/modules/Login";
import UpdatePassword from "@/modules/UpdatePassword";
import routes from "@/routes";
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Register = lazy(() => import("@/modules/Register"));
const GoogleSignup = lazy(() => import("@/modules/Register/GoogleSignup"));

const TableLab = lazy(() => import("@/modules/TableLab"));

const UnsubscribeScheduledReport = lazy(
  () => import("@/modules/ScheduledReports/Unsubscribe")
);

export const PublicRoutes: RouteObject[] = [
  // Design harness for table layout. Outside PublicLayout so it renders without
  // the login chrome, and dropped from the bundle entirely outside development —
  // it is a working surface, not a feature. It needs no user: UserProvider wraps
  // both route trees and `usePermission` tolerates a null user, so the fixture
  // tables render with nobody logged in.
  ...(IS_DEV ? [{ element: <TableLab />, path: "/table-lab" }] : []),
  // Auth screens render full-bleed (split layout), so they sit outside PublicLayout.
  { element: <Login />, path: routes.LOGIN },
  { element: <Login isAdmin />, path: "/admin" },
  ...(IS_BILLING
    ? [
        { element: <Register />, path: routes.REGISTER },
        // Second step of Google sign-up; the ticket arrives in router state.
        { element: <GoogleSignup />, path: routes.REGISTER_GOOGLE },
      ]
    : []),
  {
    // Pathless on purpose: a `path: "/"` here would tie with the Login route
    // above in RR 6.11 ranking and could render an empty Outlet at `/`.
    element: <PublicLayout />,
    children: [
      {
        element: <ForgetPassword />,
        path: routes.FORGET_PASSWORD,
      },
      {
        element: <UpdatePassword />,
        path: routes.UPDATE_PASSWORD,
      },
      {
        element: <CompleteProfile />,
        path: "/complete-profile",
      },
      // Linked from every scheduled report email; must work logged out.
      {
        element: <UnsubscribeScheduledReport />,
        path: routes.SCHEDULED_REPORTS.UNSUBSCRIBE,
      },
    ],
  },
];
